export default __webpack_public_path__ + "static/media/note-orange.3672cae1.svg";